import { Flash, Box, Button, Link, Section, Text, toast } from '@acast/decibel';
import T from 'prop-types';
import React, { Component } from 'react';
import { presentModal } from 'services/modals';
import Modal from 'shared/components/modal';
import navigateTo from 'shared/helpers/navigate-to';
import DeletionConfirmationDialog from './deletion-confirmation-dialog';

const renderDeleteErrorModal = showName => (
  <Modal
    title="Error"
    dialog={
      <Text mb={0}>
        We failed to delete <b>{showName}</b>. This might happen if you're on a shaky connection,
        but it might also be us having a temporary problem. If this error persists, please contact
        us through <Link href="mailto:support@acast.com">support@acast.com</Link>.
      </Text>
    }
    actions={Modal.Actions.OK}
  />
);

class SettingsGroupDelete extends Component {
  static propTypes = {
    show: T.object,
    onDelete: T.func,
  };

  constructor(props, ...rest) {
    super(props, ...rest);

    this.state = {
      isPending: false,
    };
  }

  handleDelete = show => {
    this.setState({ isPending: true });

    this.props
      .onDelete()
      .then(() => {
        this.setState({ isPending: false });
        navigateTo('/');
        toast.primary(`${show.name} was successfully deleted.`, { closable: true, duration: 5000 });
      })
      .catch(() => {
        this.setState({ isPending: false });
        presentModal(renderDeleteErrorModal(show.name));
      });
  };

  render() {
    const { show } = this.props;
    const { isPending } = this.state;

    return (
      <Section>
        <Text variant="h3">Delete Show</Text>
        <Flash intent="danger">
          <b>WARNING:</b> By deleting this show all associated episodes will also be permanently
          removed from Create and become unavailable to your listeners. This action cannot be
          reversed.
        </Flash>
        <Box mt={4} justifyContent="flex-end">
          <Button
            disabled={isPending}
            busy={isPending}
            variant="primary"
            intent="danger"
            onClick={() =>
              presentModal(<DeletionConfirmationDialog show={show} />).then(shouldDelete => {
                if (shouldDelete) {
                  this.handleDelete(show);
                }
              })
            }
          >
            Delete Show
          </Button>
        </Box>
      </Section>
    );
  }
}

export default SettingsGroupDelete;
